import { HeartPulse } from 'lucide-react';

export const LoadingState = () => (
  <div className="flex flex-1 items-center justify-center p-6">
    <div className="flex animate-pulse items-center">
      <HeartPulse className="mr-2 h-5 w-5 animate-ping text-red-500" />
      Loading heart rate data...
    </div>
  </div>
);
